import { css } from 'styled-components/macro';

// this could be a func if we need to change which color or border side etc
export const divider = css`
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral._30};
`;
